import {AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {distinctUntilChanged, fromEvent, map, tap} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SearchInputComponent),
    multi: true,
  }],
})
export class SearchInputComponent implements AfterViewInit, ControlValueAccessor {
  _innerValue: string;
  get innerValue () {
    return this._innerValue;
  }
  set innerValue(value: string) {
    this._innerValue = value;
    this.onChangeCallback(value);
  }
  onChangeCallback: (value: string) => void = () => {};

  @Input() placeholder: string = 'Search...';
  @Input() debounce: number = 1000;
  @Input() radiusAlways: boolean = true;
  @Input() disabled: boolean;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private translateService: TranslateService,
  ) {
    this.placeholder = this.translateService.instant('Search') + '...';
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchInput.nativeElement, 'keyup')
    .pipe(
      debounceTime(this.debounce),
      map(() => this._innerValue || ''),
      distinctUntilChanged(),
      tap((value) => this.search.emit(value)),
    ).subscribe();
  }

  resetSearchString() {
    this.innerValue = '';
    this.search.emit('');
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn.bind(this);
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: string): void {
    if (this.innerValue !== value) {
      this.innerValue = value;
    }
  }

  focus(): void {
    this.searchInput.nativeElement.focus();
  }
}
